/* ═══ VALSEN SCRIPTS v2 — assets/valsen.js ═══ */
(function(){
'use strict';
var isTouch = window.matchMedia('(hover:none)').matches || window.matchMedia('(pointer:coarse)').matches || window.innerWidth<900;

/* ── CURSEUR PLUME ── */
var Q=document.getElementById('quill'), QR=document.getElementById('quill-ring');
if(Q&&QR&&!isTouch){
  var mx=0,my=0,rx=0,ry=0,lastMx=0,curAngle=-36,isDark=false,bt=0,velX=0;
  document.querySelectorAll('[data-dark]').forEach(function(el){
    el.addEventListener('mouseenter',function(){isDark=true});
    el.addEventListener('mouseleave',function(){isDark=false});
  });
  document.addEventListener('mousemove',function(e){mx=e.clientX;my=e.clientY});
  document.addEventListener('mousedown',function(){Q.style.transition='transform .12s ease';Q.style.transform='rotate('+(curAngle-5)+'deg) scale(.88)';setTimeout(function(){Q.style.transition=''},160)});
  (function raf(){
    bt+=0.038;velX=(mx-lastMx)*.2;lastMx+=(mx-lastMx)*.14;
    var ba=Math.sin(bt)*.7, ta=-36+Math.max(-13,Math.min(13,velX*2.8));
    curAngle+=(ta-curAngle)*.07;
    var by=Math.sin(bt*1.3)*1.4;
    Q.style.left=(mx-7)+'px';Q.style.top=(my-64+by)+'px';
    Q.style.transform='rotate('+(curAngle+ba)+'deg)';
    Q.style.filter=isDark?'invert(1) brightness(1.15)':'brightness(.8)';
    QR.style.borderColor=isDark?'rgba(255,255,255,.5)':'rgba(8,8,8,.4)';
    rx+=(mx-rx)*.09;ry+=(my-ry)*.09;QR.style.left=rx+'px';QR.style.top=ry+'px';
    requestAnimationFrame(raf);
  })();
  document.querySelectorAll('a,button,.h,input,select').forEach(function(el){
    el.addEventListener('mouseenter',function(){QR.classList.add('big')});
    el.addEventListener('mouseleave',function(){QR.classList.remove('big')});
  });
  var tCV=document.getElementById('trail');
  if(tCV){
    tCV.width=innerWidth;tCV.height=innerHeight;
    var tx=tCV.getContext('2d'),dots=[];
    document.addEventListener('mousemove',function(e){dots.push({x:e.clientX,y:e.clientY,a:1,r:1.4+Math.random()*.8})});
    (function dt(){tx.clearRect(0,0,tCV.width,tCV.height);for(var i=dots.length-1;i>=0;i--){var d=dots[i];tx.beginPath();tx.arc(d.x,d.y,d.r,0,Math.PI*2);tx.fillStyle='rgba(0,0,0,'+(d.a*.08)+')';tx.fill();d.a-=.06;if(d.a<=0)dots.splice(i,1)}requestAnimationFrame(dt)})();
    window.addEventListener('resize',function(){tCV.width=innerWidth;tCV.height=innerHeight});
  }
}

/* ── SCROLL : progress + nav ── */
var pg=document.getElementById('pg'),nav=document.getElementById('nav');
window.addEventListener('scroll',function(){
  if(pg){var p=(scrollY/(document.documentElement.scrollHeight-innerHeight))*100;pg.style.width=p+'%'}
  if(nav)nav.classList.toggle('sc',scrollY>40);
},{passive:true});

/* ── FIRST LOADER (1x par session) ── */
(function(){
  var ld=document.getElementById('ld');
  if(!ld)return;
  if(sessionStorage.getItem('valsen_seen')){
    // déjà vu : on le retire tout de suite, sans transition, pour qu'aucun V n'apparaisse
    ld.style.transition='none';
    ld.classList.add('gone');
    ld.style.display='none';
  }else{
    // poser le flag IMMÉDIATEMENT pour qu'aucune autre page ne rejoue le loader,
    // même si l'utilisateur navigue avant la fin de l'animation
    sessionStorage.setItem('valsen_seen','1');
    // On n'attend plus le chargement de toutes les images : l'ecran se retire
    // des que l'animation du V a eu le temps de se jouer (~0,9 s apres l'ouverture).
    var ecoule=(window.performance&&performance.now)?performance.now():0;
    setTimeout(function(){ld.classList.add('gone');},Math.max(150,900-ecoule));
  }
})();

/* ── TRANSITION DE PAGE ── */
var ptrans=document.getElementById('ptrans');
var pageInfo={
  index:{ico:'✒',name:'Valsen',tag:'Papeterie créative'},
  product:{ico:'❦',name:'Le produit',tag:'Fiche détaillée'},
  contact:{ico:'✉',name:'Contact',tag:'Écrivez-nous'},
  histoire:{ico:'❧',name:'Notre histoire',tag:'L\'art du quotidien'},
  collections:{ico:'⚜',name:'Collections',tag:'Quatre univers'},
  boutique:{ico:'❖',name:'Boutique',tag:'Tout le catalogue'},
  packs:{ico:'❉',name:'Packs',tag:'Objets à offrir'},
  createurs:{ico:'✦',name:'Créateurs',tag:'Éditions limitées'},
  cadeaux:{ico:'🎁',name:'Cadeaux',tag:'Le moteur à cadeau'},
  journal:{ico:'❦',name:'Le Journal',tag:'Inspirations & coulisses'},
  article:{ico:'❦',name:'Le Journal',tag:'Lecture'},
  royaume:{ico:'♛',name:'Royaume',tag:'Médiéval · Épique'},
  cosmos:{ico:'✷',name:'Cosmos',tag:'Astres & galaxies'},
  foret:{ico:'❧',name:'Forêt enchantée',tag:'Nature & mystère'},
  mythologie:{ico:'⚶',name:'Mythologie',tag:'Légendes antiques'},
  faq:{ico:'?',name:'Questions fréquentes',tag:'Aide & infos'},
  livraison:{ico:'✦',name:'Livraison & retours',tag:'Tout savoir'},
  compte:{ico:'☻',name:'Mon compte',tag:'Espace personnel'},
  cgv:{ico:'§',name:'CGV',tag:'Conditions de vente'},
  mentions:{ico:'§',name:'Mentions légales',tag:'Informations légales'},
  confidentialite:{ico:'§',name:'Confidentialité',tag:'Vos données'}
};
function pageKey(href){
  var m=href.replace(/^.*\//,'').replace(/[?#].*$/,'').replace('.html','');
  if(m===''||m==='index')return 'index';
  return pageInfo[m]?m:null;
}
function fillSig(key){
  if(!ptrans)return;
  var info=pageInfo[key]||pageInfo.index;
  var ico=ptrans.querySelector('.pt-ico'); if(ico)ico.textContent=info.ico;
  var nm=ptrans.querySelector('.pt-name'); if(nm)nm.textContent=info.name;
  var tg=ptrans.querySelector('.pt-tag'); if(tg)tg.textContent=info.tag;
}
// Reveal à l'entrée : le rideau couvre déjà l'écran et REDESCEND automatiquement
// via l'animation CSS (#ptrans -> @keyframes ptDescend), pour toutes les pages.
// Le JS n'a plus à orchestrer la descente (ce qui créait un 2e écran noir sur
// certaines pages). On réactive juste la signature pour les sorties.
// La signature (nom + logo de la page) est gérée entièrement en CSS :
// invisible pendant la descente d'entrée, visible pendant la couverture (.cover)
// au clic. Rien à faire ici pour l'entrée.
document.querySelectorAll('a[href$=".html"]').forEach(function(a){
  a.addEventListener('click',function(e){
    var href=a.getAttribute('href');
    if(!href||href.charAt(0)==='#'||a.target==='_blank')return;
    var key=pageKey(href);
    if(!key||!ptrans)return;
    e.preventDefault();
    fillSig(key);
    // Couper l'animation d'entrée (ptDescend) pour reprendre la main sur le rideau
    ptrans.style.animation='none';
    ptrans.classList.remove('reveal');
    ptrans.style.transition='none';
    ptrans.style.transform='translateY(-100%)';
    requestAnimationFrame(function(){
      ptrans.style.transition='';
      ptrans.style.transform='';
      ptrans.classList.add('cover');
      setTimeout(function(){window.location.href=href},620);
    });
  });
});

/* ── MARBRE ── */
window.vMarble=function(id,cfg){
  var cv=document.getElementById(id);if(!cv)return;
  var pr=Math.min(window.devicePixelRatio||1,2);
  var rect=cv.parentElement.getBoundingClientRect();
  var W=Math.round(rect.width||innerWidth),H=Math.round(rect.height||600);
  if(W===0||H===0)return;
  cv.width=W*pr;cv.height=H*pr;cv.style.width=W+'px';cv.style.height=H+'px';
  var ctx=cv.getContext('2d');ctx.scale(pr,pr);
  ctx.fillStyle=cfg.bg;ctx.fillRect(0,0,W,H);
  for(var i=0;i<cfg.n;i++){
    var x,y,s=Math.floor(Math.random()*4);
    if(s===0){x=Math.random()*W;y=0}else if(s===1){x=W;y=Math.random()*H}else if(s===2){x=Math.random()*W;y=H}else{x=0;y=Math.random()*H}
    ctx.beginPath();ctx.moveTo(x,y);
    for(var j=0;j<3+Math.floor(Math.random()*4);j++){
      var cx1=x+(Math.random()-.5)*W*.8,cy1=y+(Math.random()-.5)*H*.8,cx2=x+(Math.random()-.5)*W*.6,cy2=y+(Math.random()-.5)*H*.6,ex=x+(Math.random()-.5)*W*1.2,ey=y+(Math.random()-.5)*H*1.2;
      ctx.bezierCurveTo(cx1,cy1,cx2,cy2,ex,ey);x=ex;y=ey;
    }
    ctx.strokeStyle=cfg.vc;ctx.lineWidth=0.4+Math.random()*2.8;ctx.globalAlpha=(0.028+Math.random()*.06)*cfg.am;ctx.stroke();
  }
  for(var k=0;k<cfg.n*2;k++){
    var xx=Math.random()*W,yy=Math.random()<.5?0:H;
    ctx.beginPath();ctx.moveTo(xx,yy);
    for(var l=0;l<2;l++){var cx=xx+(Math.random()-.5)*W*.5,cy=yy+(Math.random()-.5)*H*.5,exx=xx+(Math.random()-.5)*W*.8,eyy=yy+(Math.random()-.5)*H*.8;ctx.quadraticCurveTo(cx,cy,exx,eyy);xx=exx;yy=eyy}
    ctx.strokeStyle=cfg.vc;ctx.lineWidth=0.2+Math.random()*.7;ctx.globalAlpha=(0.01+Math.random()*.025)*cfg.am;ctx.stroke();
  }
  ctx.globalAlpha=1;
};
function initMarble(){
  document.querySelectorAll('canvas[data-marble]').forEach(function(cv){
    var dark=cv.getAttribute('data-marble')==='dark';
    vMarble(cv.id,dark?{bg:'#070707',vc:'rgba(255,255,255,1)',n:18,am:.92}:{bg:'#F7F7F7',vc:'rgba(0,0,0,1)',n:15,am:1.05});
  });
}
initMarble();
// Sur mobile, la barre d'adresse qui apparait/disparait au defilement declenche
// un "resize" (hauteur seule) : on ne redessine le marbre que si la LARGEUR
// change (rotation...), sinon il changeait de motif en pleine navigation.
// Ordinateur : comportement d'origine inchange.
var rt,mbW=innerWidth;window.addEventListener('resize',function(){
  var tactile=window.matchMedia('(hover:none),(pointer:coarse),(max-width:900px)').matches;
  if(tactile&&innerWidth===mbW)return;
  mbW=innerWidth;clearTimeout(rt);rt=setTimeout(initMarble,200);
});

/* ── REVEAL ── */
var obs=new IntersectionObserver(function(en){en.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');obs.unobserve(e.target)}})},{threshold:.1,rootMargin:'0px 0px -40px 0px'});
document.querySelectorAll('.rv,.rv-l,.rv-r,.rv-sc,.rv-clip,.stat,[data-stagger],[data-reveal]').forEach(function(el){obs.observe(el)});

/* ── NAV MOBILE ── */
var burger=document.getElementById('nburger'),nmobile=document.getElementById('nmobile');
if(burger&&nmobile){
  burger.addEventListener('click',function(){
    burger.classList.toggle('open');nmobile.classList.toggle('open');
    document.body.style.overflow=nmobile.classList.contains('open')?'hidden':'';
  });
}

/* ── PANIER (items + drawer) ── */
var cartItems=[];
try{cartItems=JSON.parse(sessionStorage.getItem('valsen_cart_items')||'[]')}catch(e){cartItems=[]}
function cartCountTotal(){var n=0;cartItems.forEach(function(i){n+=i.q});return n;}
function cartTotalPrice(){var t=0;cartItems.forEach(function(i){t+=i.p*i.q});return t;}
function cartFmt(p){return p.toFixed(2).replace('.',',')+' €';}
function saveCart(){sessionStorage.setItem('valsen_cart_items',JSON.stringify(cartItems));}
function updateCart(){
  var n=cartCountTotal();
  document.querySelectorAll('.ncta-count').forEach(function(c){c.textContent=n;c.style.opacity=n>0?'1':'.55';});
}
// compat : ancienne variable utilisée ailleurs
var cartCount=cartCountTotal();
function addToCart(name,price,cat,univ){
  var key=name;
  var found=null;
  cartItems.forEach(function(i){if(i.n===key)found=i;});
  if(found){found.q++;}else{cartItems.push({n:name,p:price||0,c:cat||'',u:univ||'',q:1});}
  cartCount=cartCountTotal();
  saveCart();updateCart();renderCart();
  showToast(name);
}
window.addToCart=addToCart;
updateCart();

var toast=document.getElementById('toast');
function showToast(name){
  if(!toast)return;
  var t=toast.querySelector('.toast-t');if(t)t.textContent='Ajouté au panier';
  var s=toast.querySelector('.toast-s');if(s)s.textContent=name||'';
  toast.classList.add('show');
  clearTimeout(toast._t);toast._t=setTimeout(function(){toast.classList.remove('show')},2600);
}
window.showToast=showToast;

/* Drawer */
var drawer=document.getElementById('cart-drawer');
var overlay=document.getElementById('cart-overlay');
function openCart(){if(drawer){drawer.classList.add('open');overlay.classList.add('open');document.body.style.overflow='hidden';renderCart();}}
function closeCart(){if(drawer){drawer.classList.remove('open');overlay.classList.remove('open');document.body.style.overflow='';}}
window.openCart=openCart;
if(overlay)overlay.addEventListener('click',closeCart);
var cartCloseBtn=document.getElementById('cart-close');
if(cartCloseBtn)cartCloseBtn.addEventListener('click',closeCart);
document.addEventListener('keydown',function(e){if(e.key==='Escape')closeCart();});
// ouvrir au clic sur le bouton panier de la nav
document.querySelectorAll('.ncta').forEach(function(b){b.addEventListener('click',function(e){e.preventDefault();openCart();});});

function renderCart(){
  var body=document.getElementById('cart-body');
  var foot=document.getElementById('cart-foot');
  var totalEl=document.getElementById('cart-total');
  if(!body)return;
  if(cartItems.length===0){
    body.innerHTML='<div class="cart-empty"><div class="cart-empty-ico">🛍</div><div class="cart-empty-t">Votre panier est vide</div><div class="cart-empty-s">Parcourez la boutique et ajoutez vos coups de cœur.</div><a class="btn-b h" href="/collections/all" style="margin-top:6px"><span>Voir la boutique</span></a></div>';
    if(foot)foot.style.display='none';
    return;
  }
  if(foot)foot.style.display='';
  body.innerHTML=cartItems.map(function(it,idx){
    var initial=(it.n||'V').charAt(0).toUpperCase();
    return '<div class="cart-item"><div class="cart-item-vig">'+initial+'</div><div class="cart-item-info"><div class="cart-item-name">'+it.n+'</div><div class="cart-item-cat">'+(it.c||'')+'</div><div class="cart-item-row"><div class="cart-qty"><button data-act="dec" data-i="'+idx+'">−</button><span>'+it.q+'</span><button data-act="inc" data-i="'+idx+'">+</button></div><div class="cart-item-price">'+cartFmt(it.p*it.q)+'</div></div><button class="cart-item-rm" data-act="rm" data-i="'+idx+'">Retirer</button></div></div>';
  }).join('');
  if(totalEl)totalEl.textContent=cartFmt(cartTotalPrice());
  body.querySelectorAll('[data-act]').forEach(function(btn){
    btn.addEventListener('click',function(){
      var i=parseInt(btn.getAttribute('data-i'),10),act=btn.getAttribute('data-act');
      if(act==='inc')cartItems[i].q++;
      else if(act==='dec'){cartItems[i].q--;if(cartItems[i].q<=0)cartItems.splice(i,1);}
      else if(act==='rm')cartItems.splice(i,1);
      cartCount=cartCountTotal();saveCart();updateCart();renderCart();
    });
  });
}
renderCart();

/* Parse prix depuis une carte produit */
function parsePrice(txt){if(!txt)return 0;var m=txt.replace(/\s/g,'').replace(',','.').match(/([0-9]+(\.[0-9]+)?)/);return m?parseFloat(m[1]):0;}
function bindAdd(el){
  el.addEventListener('click',function(e){
    e.preventDefault();e.stopPropagation();
    var card=el.closest('.pc');
    var nm=card?(card.querySelector('.pc-name')||{}).textContent:'Article';
    var price=card?parsePrice((card.querySelector('.pc-price')||{}).textContent):0;
    var cat=card?(card.querySelector('.pc-cat')||{}).textContent:'';
    addToCart(nm,price,cat);
    var sp=el.querySelector('span');if(sp){var o=sp.textContent;el.classList.add('added');sp.textContent='✓';setTimeout(function(){sp.textContent=o;el.classList.remove('added')},1200);}
  });
}
document.querySelectorAll('.pc-add,.pc-quick').forEach(bindAdd);

/* ── CATALOGUE SCROLL ── */
var cs=document.getElementById('cat-scroll');
if(cs){
  var cw=282,prev=document.getElementById('cat-prev'),next=document.getElementById('cat-next');
  if(prev)prev.addEventListener('click',function(){cs.scrollBy({left:-cw*2,behavior:'smooth'})});
  if(next)next.addEventListener('click',function(){cs.scrollBy({left:cw*2,behavior:'smooth'})});
  var down=false,sx=0,sl=0;
  cs.addEventListener('mousedown',function(e){down=true;cs.style.cursor='grabbing';sx=e.pageX-cs.offsetLeft;sl=cs.scrollLeft});
  cs.addEventListener('mouseleave',function(){down=false;cs.style.cursor='grab'});
  cs.addEventListener('mouseup',function(){down=false;cs.style.cursor='grab'});
  cs.addEventListener('mousemove',function(e){if(!down)return;e.preventDefault();cs.scrollLeft=sl-((e.pageX-cs.offsetLeft)-sx)*1.4});
  var ts=0,tsl=0;
  cs.addEventListener('touchstart',function(e){ts=e.touches[0].pageX;tsl=cs.scrollLeft},{passive:true});
  cs.addEventListener('touchmove',function(e){cs.scrollLeft=tsl+(ts-e.touches[0].pageX)},{passive:true});
}

/* ── MOTEUR À CADEAU v3 (scoring + vignettes) ── */
var GIFT_UNIV={
  royaume:{label:'Royaume',c1:'#1A0820',c2:'#2A0830',accent:'rgba(255,180,60,.55)',ico:'M40,8 L48,28 L70,28 L52,42 L59,64 L40,50 L21,64 L28,42 L10,28 L32,28 Z'},
  cosmos:{label:'Cosmos',c1:'#0A0A14',c2:'#0B1426',accent:'rgba(126,202,240,.55)',ico:'M40,12 a28,28 0 1,0 .1,0 M40,28 a12,12 0 1,1 -.1,0'},
  foret:{label:'Forêt',c1:'#0C110C',c2:'#1C3420',accent:'rgba(139,196,160,.6)',ico:'M40,10 C30,26 24,30 24,42 a16,16 0 0,0 32,0 C56,30 50,26 40,10 Z'},
  mythologie:{label:'Mythologie',c1:'#110A14',c2:'#260D38',accent:'rgba(212,168,85,.6)',ico:'M22,26 L58,26 L54,60 L26,60 Z M30,26 L30,60 M40,26 L40,60 M50,26 L50,60 M18,26 L62,26 L62,20 L18,20 Z'}
};
function geVignette(u){
  var U=GIFT_UNIV[u]||GIFT_UNIV.royaume;
  return '<div class="ge-vig" style="background:linear-gradient(145deg,'+U.c1+','+U.c2+')"><svg viewBox="0 0 80 80" width="46" height="46" fill="none" stroke="'+U.accent+'" stroke-width="1.1"><path d="'+U.ico+'"/></svg></div>';
}
// Vignette pour la nouvelle DA (remplit .gx-prod-vig)
function gxVignette(u){
  var U=GIFT_UNIV[u]||GIFT_UNIV.royaume;
  return '<div style="position:absolute;inset:0;background:linear-gradient(150deg,'+U.c1+','+U.c2+')"></div><svg viewBox="0 0 80 80" width="52" height="52" fill="none" stroke="'+U.accent+'" stroke-width="1.1" style="position:relative;z-index:1">'+'<path d="'+U.ico+'"/></svg>';
}
var GIFT_CATALOG=(typeof window!=='undefined' && window.VALSEN_CATALOG && window.VALSEN_CATALOG.length) ? window.VALSEN_CATALOG : [];
// Catalogue charge en arriere-plan (voir theme.liquid) : on le recupere des qu'il est pret
if(window.valsenCatalogue){ window.valsenCatalogue(function(d){ GIFT_CATALOG=d||[]; }); }
var geBudgetRanges=[[0,20],[20,50],[50,100],[100,9999]];
function geFmt(p){return p.toFixed(2).replace('.',',')+' €';}
var GE_TINT={
  royaume:{ink:'#7a5c12',sp:'#D8C9A8'},
  cosmos:{ink:'#3a4a6e',sp:'#C3CEE2'},
  foret:{ink:'#2f5a3c',sp:'#BBD3C2'},
  mythologie:{ink:'#5a3c72',sp:'#D2C2E0'}
};
function geVisual(cat,u){
  var T=GE_TINT[u]||GE_TINT.royaume;var c=(cat||'').toLowerCase();var ink=T.ink,sp=T.sp;
  if(c.indexOf('papeterie')>=0||c.indexOf('carnet')>=0||c.indexOf('agenda')>=0)
    return '<div class="pv"><div class="book" style="width:96px;height:134px"><div class="book-sp" style="background:'+sp+'"></div><div class="book-front" style="background:#FBF7EF;left:10px"><span style="font-family:Cormorant Garamond,serif;font-size:40px;font-weight:600;color:'+ink+'">V</span></div></div></div>';
  if(c.indexOf('vêtement')>=0||c.indexOf('vetement')>=0||c.indexOf('hoodie')>=0||c.indexOf('t-shirt')>=0)
    return '<div class="pv"><svg width="104" height="94" viewBox="0 0 100 90"><path d="M18,18 L0,36 L18,41 L18,82 L82,82 L82,41 L100,36 L82,18 L64,9 Q50,0 36,9Z" fill="#FBF7EF" stroke="'+ink+'" stroke-width=".8"/><text x="50" y="56" text-anchor="middle" font-family="Cormorant Garamond,serif" font-size="9" fill="'+ink+'" letter-spacing="3">VALSEN</text></svg></div>';
  if(c.indexOf('bagagerie')>=0||c.indexOf('sac')>=0||c.indexOf('tote')>=0||c.indexOf('trousse')>=0)
    return '<div class="pv"><svg width="84" height="102" viewBox="0 0 82 100"><path d="M24,26 Q24,12 41,12 Q58,12 58,26" fill="none" stroke="'+ink+'" stroke-width="2" stroke-linecap="round"/><rect x="6" y="26" width="70" height="68" rx="3" fill="#FBF7EF" stroke="'+ink+'" stroke-width=".8"/><text x="41" y="68" text-anchor="middle" font-family="Cormorant Garamond,serif" font-size="24" font-weight="600" fill="'+ink+'">V</text></svg></div>';
  if(c.indexOf('accessoire')>=0||c.indexOf('stylo')>=0)
    return '<div class="pv"><svg width="40" height="128" viewBox="0 0 40 128"><rect x="15" y="20" width="10" height="86" rx="2" fill="#FBF7EF" stroke="'+ink+'" stroke-width=".8"/><path d="M15,20 L20,4 L25,20Z" fill="'+ink+'"/><rect x="15" y="100" width="10" height="10" rx="1" fill="'+ink+'"/></svg></div>';
  if(c.indexOf('décoration')>=0||c.indexOf('decoration')>=0||c.indexOf('poster')>=0||c.indexOf('carte')>=0)
    return '<div class="pv"><div style="width:104px;height:140px;background:#FBF7EF;border:1px solid '+ink+';display:flex;align-items:center;justify-content:center;box-shadow:5px 10px 24px rgba(0,0,0,.12)"><span style="font-family:Cormorant Garamond,serif;font-size:46px;color:'+ink+'">V</span></div></div>';
  return '<div class="pv"><svg width="120" height="104" viewBox="0 0 120 104"><rect x="14" y="34" width="92" height="60" rx="2" fill="#FBF7EF" stroke="'+ink+'" stroke-width=".9"/><rect x="14" y="34" width="92" height="14" fill="'+sp+'"/><rect x="54" y="18" width="12" height="76" fill="'+ink+'" opacity=".5"/><path d="M60,18 Q48,4 42,16 Q50,22 60,18 Q70,22 78,16 Q72,4 60,18Z" fill="'+ink+'" opacity=".7"/></svg></div>';
}
/* Moteur a cadeaux : regles strictes + classement.
   1) BUDGET : strict, jamais de produit hors de la tranche choisie.
   2) POUR QUI : deduit de l'occasion et de l'age, lu sur les balises genre: des produits.
      - Fete des meres : jamais de produit marque uniquement homme (et inversement pour les peres).
      - Bebe / naissance : vetements bebe uniquement ; enfant : vetements enfant ; adultes : pas de vetements bebe/enfant.
   3) SAISON : un produit balise pour un evenement (halloween, noel, valentin, meres, peres, paques)
      n'est propose que pour cet evenement (Halloween : seulement en octobre).
   4) VARIETE : 2 produits maximum par sous-categorie (type:), 5 idees au total.
   5) CLASSEMENT : correspondance exacte d'occasion / d'age en tete, puis prix le plus proche
      du milieu de la tranche. Plus aucun hasard : memes criteres = memes resultats. */
function geTags(item){return (item.tg||[]).map(function(t){return String(t).toLowerCase().trim();});}
function geGenres(tags){
  var g=[];tags.forEach(function(t){if(t.indexOf('genre:')===0)g.push(t.slice(6).replace(/é/g,'e'));});
  return g; // vide = mixte
}
function geType(tags){for(var i=0;i<tags.length;i++){if(tags[i].indexOf('type:')===0)return tags[i].slice(5);}return '';}
var GE_EVENTS={halloween:'halloween',noel:'noel',valentin:'valentin','saint-valentin':'valentin',meres:'meres','fete-des-meres':'meres',peres:'peres','fete-des-peres':'peres',paques:'paques',rentree:'rentree'};
function geRecommend(age,occ,budgetIdx){
  var range=geBudgetRanges[budgetIdx]||[0,9999];
  var mois=new Date().getMonth(); // 9 = octobre
  var adulte=(age==='a1'||age==='a2'||age==='senior');
  var bebe=(age==='bebe'||age==='naissance');
  var enfant=(age==='enfant');
  var ok=[];
  GIFT_CATALOG.forEach(function(item){
    // 1. Budget strict
    if(!(item.p>=range[0]&&item.p<=range[1]))return;
    var tags=geTags(item), genres=geGenres(tags), type=geType(tags);
    var estVet=/v[eê]tement/i.test(item.c||'');
    var mixte=genres.length===0;
    // 2. Pour qui : occasion
    if(occ==='meres'&&!mixte&&genres.indexOf('femme')<0)return;
    if(occ==='peres'&&!mixte&&genres.indexOf('homme')<0)return;
    // 2. Pour qui : age (vetements seulement, les tailles comptent)
    if(estVet){
      if(bebe&&genres.indexOf('bebe')<0)return;
      if(enfant&&genres.indexOf('enfant')<0)return;
      if((adulte||occ==='meres'||occ==='peres'||occ==='valentin')&&!mixte&&genres.indexOf('homme')<0&&genres.indexOf('femme')<0)return;
    }
    // 3. Saison / evenement
    var evt=null;tags.forEach(function(t){if(GE_EVENTS[t])evt=GE_EVENTS[t];});
    if(evt==='halloween'&&mois!==9&&occ!=='halloween')return;
    if(evt&&evt!=='halloween'&&evt!==occ)return;
    // 5. Score
    var s=0;
    if(occ&&item.occ&&item.occ.indexOf(occ)>=0&&item.occ.length<6)s+=4;   // balise d'occasion explicite
    if(evt&&evt===occ)s+=3;
    if(age&&item.ages&&item.ages.indexOf(age)>=0&&item.ages.length<7)s+=3; // balise d'age explicite
    if(bebe&&genres.indexOf('bebe')>=0)s+=3;
    if(enfant&&genres.indexOf('enfant')>=0)s+=3;
    if(occ==='meres'&&genres.indexOf('femme')>=0)s+=2;
    if(occ==='peres'&&genres.indexOf('homme')>=0)s+=2;
    var milieu=range[1]>=9999?range[0]*1.5:(range[0]+range[1])/2;
    s-=Math.abs(item.p-milieu)/Math.max(milieu,1); // prix proche du coeur de budget
    ok.push({item:item,s:s,type:type||item.c});
  });
  ok.sort(function(a,b){return b.s-a.s;});
  // 4. Variete : 2 max par sous-categorie
  var parType={},top=[];
  ok.forEach(function(r){if(top.length>=5)return;var k=r.type;parType[k]=(parType[k]||0)+1;if(parType[k]<=2)top.push(r);});
  if(top.length<5){ok.forEach(function(r){if(top.length<5&&top.indexOf(r)<0)top.push(r);});}
  return top;
}
/* ── MOTEUR À CADEAUX — UI "Atelier" ── */
// Déco festive flottante (étincelles) — moteur + teaser, hors du guard
['gx-deco','gt-deco'].forEach(function(decoId){
  var deco=document.getElementById(decoId);
  if(!deco)return;
  var glyphs=['✦','✧','❋','·'];
  for(var i=0;i<14;i++){
    var s=document.createElement('span');
    s.textContent=glyphs[i%glyphs.length];
    s.style.left=(Math.random()*100)+'%';
    s.style.top=(Math.random()*100)+'%';
    s.style.fontSize=(8+Math.random()*12)+'px';
    s.style.animationDuration=(7+Math.random()*8)+'s';
    s.style.animationDelay=(Math.random()*8)+'s';
    deco.appendChild(s);
  }
});
(function(){
  var root=document.querySelector('[data-gift]');
  if(!root)return;
  if(window.valsenCatalogue)window.valsenCatalogue();
  var state={age:'',occ:'',budget:1};
  var labels={age:'tous âges',occ:'toute occasion',budget:'20 à 50 €'};

  // Sélection dans une liste d'options (age/occ)
  function bindOptList(id,field){
    var box=document.getElementById(id);if(!box)return;
    box.addEventListener('click',function(e){
      var b=e.target.closest('.gx-opt');if(!b)return;
      box.querySelectorAll('.gx-opt').forEach(function(x){x.classList.remove('sel')});
      b.classList.add('sel');
      state[field]=b.getAttribute('data-v');
      labels[field]=b.getAttribute('data-label');
      updateRecap();
    });
  }
  bindOptList('gx-age','age');
  (function(){
    if(new Date().getMonth()!==9)return; // octobre uniquement
    var box=document.getElementById('gx-occ');if(!box)return;
    if(box.querySelector('.gx-opt[data-v="halloween"]'))return;
    var modele=box.querySelector('.gx-opt');if(!modele)return;
    var ancien=(modele.getAttribute('data-label')||'').trim();
    var opt=modele.cloneNode(true);
    opt.classList.remove('sel');
    opt.setAttribute('data-v','halloween');
    opt.setAttribute('data-label','Halloween');
    // remplace le libelle visible (et l'emoji eventuel) sans toucher a la structure
    var feuilles=[];
    (function parcours(n){n.childNodes.forEach(function(c){if(c.nodeType===3&&c.textContent.trim())feuilles.push(c);else if(c.nodeType===1)parcours(c);});})(opt);
    var remplace=false;
    feuilles.forEach(function(f){
      var t=f.textContent.trim();
      if(!remplace&&(t.toLowerCase()===ancien.toLowerCase()||/[a-zà-ÿ]{3,}/i.test(t))){f.textContent=f.textContent.replace(t,'Halloween');remplace=true;}
      else if(/^[^\w\s]{1,3}$/.test(t)){f.textContent=f.textContent.replace(t,'🎃');}
    });
    box.appendChild(opt);
  })();
  bindOptList('gx-occ','occ');
  // Budget
  var bud=document.getElementById('gx-budget');
  if(bud)bud.addEventListener('click',function(e){
    var b=e.target.closest('.gx-bbt');if(!b)return;
    bud.querySelectorAll('.gx-bbt').forEach(function(x){x.classList.remove('sel')});
    b.classList.add('sel');
    state.budget=parseInt(b.getAttribute('data-b'),10);
    labels.budget=b.getAttribute('data-label');
    updateRecap();
  });
  function updateRecap(){
    var r=document.getElementById('gx-recap');
    if(r)r.innerHTML='Pour <b>'+labels.age+'</b>, <b>'+labels.occ+'</b>, <b>'+labels.budget+'</b>';
  }

  // Recherche
  var go=document.getElementById('gx-go');
  if(go)go.addEventListener('click',function(){
    go.classList.add('loading');
    var lancer=function(){
    var recs=geRecommend(state.age,state.occ,state.budget);
    setTimeout(function(){
      go.classList.remove('loading');
      var grid=document.getElementById('gx-grid');
      if(grid&&!recs.length){
        grid.innerHTML='<p style="grid-column:1/-1;text-align:center;padding:40px 20px;color:var(--mid);font-size:14px;line-height:1.7">Pas encore de pièce qui corresponde à tous ces critères.<br>Essayez une autre tranche de budget ou une autre occasion.</p>';
      }
      else if(grid){
        grid.innerHTML=recs.map(function(r,i){
          var x=r.item;var U=GIFT_UNIV[x.u];
          var TINT={royaume:'linear-gradient(160deg,#F6EFDF,#EBDFC4)',cosmos:'linear-gradient(160deg,#EEF1F8,#DDE4F0)',foret:'linear-gradient(160deg,#EAF2EC,#D7E6DC)',mythologie:'linear-gradient(160deg,#F3ECF7,#E6D9F0)'};
          var bg=TINT[x.u]||TINT.royaume;
          // Photo reelle du produit si le catalogue la fournit ; sinon visuel dessine (repli)
          var visuel = x.img
            ? '<img class="pc-ibg" src="'+String(x.img).replace(/"/g,'&quot;')+'" alt="" loading="lazy" style="width:100%;height:100%;object-fit:cover">'
            : '<div class="pc-ibg" style="background:'+bg+'"></div>'+geVisual(x.c,x.u);
          // Variante unique et disponible : ajout direct au vrai panier Shopify.
          // Plusieurs variantes (tailles, couleurs) : "Choisir" ouvre la fiche.
          var direct=(x.nv===1&&x.v&&x.dispo!==false);
          var nomSur=x.n.replace(/"/g,'&quot;');
          return '<a class="pc h" href="'+(x.url||'/search')+'" data-n="'+nomSur+'" data-p="'+x.p+'" data-c="'+x.c+'"'
            +(direct?' data-variant-id="'+x.v+'" data-name="'+nomSur+'"':'')+' style="--d:'+(i*0.09)+'s">'
            +'<div class="pc-img"'+(x.img?'':' style="background:'+bg+'"')+'>'+visuel
            +(U?'<div class="pc-badge">'+U.label+'</div>':'')
            +'<div class="pc-quick"><svg viewBox="0 0 16 16" fill="none"><path d="M2 2H3.5L5 10H12L13.5 5H4.5" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/></svg>'+'Ajouter au panier'+'</div>'
            +'</div>'
            +'<div class="pc-body"><div class="pc-name">'+x.n+'</div><div class="pc-cat">'+x.c+'</div>'
            +'<div class="pc-foot"><span class="pc-price">'+geFmt(x.p)+'</span>'
            +(direct?'<button class="pc-add h" data-add aria-label="Ajouter au panier"><span>+</span></button>'
                    :'<span class="pc-add h" aria-label="Ajouter au panier"><span>+</span></span>')
            +'</div></div>'
            +'</a>';
        }).join('');
        grid.querySelectorAll('[data-add]').forEach(function(el){
          el.addEventListener('click',function(e){
            e.preventDefault();e.stopPropagation();
            if(window.valsenAddVariant)return; // le vrai panier Shopify gere l'ajout
            var card=el.closest('.pc');
            addToCart(card.getAttribute('data-n'),parseFloat(card.getAttribute('data-p')),card.getAttribute('data-c'));
            el.classList.add('added');
          });
        });
      }
      (function(){
        var res=document.getElementById('gx-results');if(!res)return;
        var h=res.querySelector('h2')||res.querySelector('h3');if(!h)return;
        if(!h.getAttribute('data-orig'))h.setAttribute('data-orig',h.innerHTML);
        var orig=h.getAttribute('data-orig');
        var n=recs.length;
        var MOTS=['Aucune','Une','Deux','Trois','Quatre','Cinq'];
        if(n===5||!/Cinq\s+id[ée]es/i.test(orig)){h.innerHTML=orig;return;}
        if(n===0){h.innerHTML=orig.replace(/Cinq\s+id[ée]es/i,'Aucune idée pour l’instant');return;}
        h.innerHTML=orig.replace(/Cinq\s+id[ée]es/i,MOTS[n]+(n>1?' idées':' idée'));
      })();
      var eb=document.getElementById('gx-res-eyebrow');
      if(eb){
        var parts=[];
        if(labels.age!=='tous âges')parts.push(labels.age);
        if(labels.occ!=='toute occasion')parts.push(labels.occ);
        eb.textContent=parts.length?('Votre sélection · '+parts.join(' · ')):'Votre sélection sur mesure';
      }
      var res=document.getElementById('gx-results');
      if(res){res.classList.add('show');setTimeout(function(){res.scrollIntoView({behavior:'smooth',block:'nearest'})},60);}
    },680);
    };
    if(window.valsenCatalogue)window.valsenCatalogue(lancer); else lancer();
  });
})();

/* ── PARALLAXE HERO ── */
var heroCanvas=document.querySelector('.hero-canvas');
var heroInner=document.querySelector('.hero-inner');
if(heroCanvas&&!isTouch){
  window.addEventListener('scroll',function(){
    var y=scrollY;
    if(y<window.innerHeight){
      heroCanvas.style.transform='translateY('+(y*0.25)+'px) scale(1.05)';
      if(heroInner)heroInner.style.transform='translateY('+(y*0.12)+'px)';
      if(heroInner)heroInner.style.opacity=Math.max(0,1-y/(window.innerHeight*0.7));
    }
  },{passive:true});
}

/* ── MAGNÉTISME BOUTONS (subtil, hors boutons hero) ── */
if(!isTouch){
  document.querySelectorAll('.ge-cta,.nl-go').forEach(function(btn){
    btn.addEventListener('mousemove',function(e){
      var r=btn.getBoundingClientRect();
      var x=e.clientX-r.left-r.width/2, y=e.clientY-r.top-r.height/2;
      btn.style.transform='translate('+(x*0.08)+'px,'+(y*0.1)+'px)';
    });
    btn.addEventListener('mouseleave',function(){btn.style.transform=''});
  });
}

/* ── TILT CARTES PRODUIT (léger) ── */
if(!isTouch){
  document.querySelectorAll('.pc').forEach(function(card){
    var img=card.querySelector('.pv');
    if(!img)return;
    card.addEventListener('mousemove',function(e){
      var r=card.getBoundingClientRect();
      var px=(e.clientX-r.left)/r.width-0.5, py=(e.clientY-r.top)/r.height-0.5;
      img.style.transform='translateY(-8px) rotate(-1deg) translate('+(px*10)+'px,'+(py*10)+'px)';
    });
    card.addEventListener('mouseleave',function(){img.style.transform=''});
  });
}

/* ── PAGE PRODUIT ── */
(function(){
  var add=document.getElementById('pp-add');
  if(!add)return;
  // Options (swatches)
  function bindSwatch(groupId,valId){
    var g=document.getElementById(groupId);if(!g)return;
    g.addEventListener('click',function(e){
      var b=e.target.closest('.pp-sw');if(!b)return;
      g.querySelectorAll('.pp-sw').forEach(function(x){x.classList.remove('active')});
      b.classList.add('active');
      var lbl=document.getElementById(valId);
      if(lbl&&b.getAttribute('data-v'))lbl.textContent=b.getAttribute('data-v');
    });
  }
  bindSwatch('pp-fmt','pp-fmt-val');
  bindSwatch('pp-int','pp-int-val');
  bindSwatch('pp-col','pp-col-val');
  // Quantité
  var qty=1,qEl=document.getElementById('pp-qty')||document.createElement('span');
  var minus=document.getElementById('pp-minus'),plus=document.getElementById('pp-plus');
  if(minus)minus.addEventListener('click',function(){if(qty>1){qty--;qEl.textContent=qty;}});
  if(plus)plus.addEventListener('click',function(){qty++;qEl.textContent=qty;});
  // Ajout panier
  add.addEventListener('click',function(){
    // Panier de demonstration : neutralise si la fiche possede le formulaire
    // Shopify (le pont valsen-shopify-cart.js gere le vrai ajout au panier).
    if(add.closest('form'))return;
    var name=(document.querySelector('.pp-name')||{}).textContent||'Article';
    var fmt=(document.getElementById('pp-fmt-val')||{}).textContent||'';
    var col=(document.getElementById('pp-col-val')||{}).textContent||'';
    var price=parsePrice((document.getElementById('pp-price')||{}).textContent);
    var label=name+(col?' · '+col:'');
    for(var i=0;i<qty;i++){addToCart(label,price,'Papeterie · '+fmt);}
    add.classList.add('ok');var sp=add.querySelector('span');var o=sp?sp.textContent:'';
    if(sp)sp.textContent='✓ Ajouté';
    setTimeout(function(){add.classList.remove('ok');if(sp)sp.textContent=o;},1400);
    openCart();
  });
  // Wishlist
  var wish=document.getElementById('pp-wish');
  if(wish)wish.addEventListener('click',function(){wish.classList.toggle('on');});
  // Miniatures (change le visuel principal - démo)
  document.querySelectorAll('.pp-thumb').forEach(function(t){
    t.addEventListener('click',function(){
      document.querySelectorAll('.pp-thumb').forEach(function(x){x.classList.remove('active')});
      t.classList.add('active');
    });
  });
  // Accordéon produit
  document.querySelectorAll('.pp-acc-item').forEach(function(item){
    var head=item.querySelector('.pp-acc-head');
    var body=item.querySelector('.pp-acc-body');
    if(item.classList.contains('open')&&body)body.style.maxHeight=body.scrollHeight+'px';
    if(head)head.addEventListener('click',function(){
      var isOpen=item.classList.contains('open');
      document.querySelectorAll('.pp-acc-item').forEach(function(i){
        i.classList.remove('open');var b=i.querySelector('.pp-acc-body');if(b)b.style.maxHeight='0px';
      });
      if(!isOpen){item.classList.add('open');if(body)body.style.maxHeight=body.scrollHeight+'px';}
    });
  });
})();

/* ── FORMULAIRE CONTACT ── */
/* (ancien faux envoi du formulaire de contact retiré : l'envoi est géré dans snippets/contact-content.liquid) */

/* (bandeau cookies du thème retiré : la bannière cookies de Shopify s'en charge) */

/* ── RECHERCHE FLOUE (tolérante aux fautes) ── */
(function(){
  var input=document.getElementById('nsearch-in');
  var results=document.getElementById('nsearch-results');
  if(!input||!results)return;

  // Normalisation : minuscules, sans accents, sans doublons de lettres, sans ponctuation
  function normalize(s){
    return (s||'').toLowerCase()
      .normalize('NFD').replace(/[\u0300-\u036f]/g,'')   // enlève accents
      .replace(/['’\u2019-]/g,'')                         // tirets/apostrophes soudés ("t-shirt"->"tshirt", "tsh" matche dès 3 lettres)
      .replace(/[^a-z0-9\s]/g,' ')                        // ponctuation -> espace
      .replace(/(.)\1+/g,'$1')                            // lettres doublées -> simple (eg. "carnett"->"carnet")
      .replace(/\s+/g,' ').trim();
  }
  // Distance de Levenshtein (limitée)
  function lev(a,b){
    if(a===b)return 0;
    var m=a.length,n=b.length;
    if(!m)return n; if(!n)return m;
    var prev=[],cur=[],i,j;
    for(j=0;j<=n;j++)prev[j]=j;
    for(i=1;i<=m;i++){
      cur[0]=i;
      for(j=1;j<=n;j++){
        var cost=a.charCodeAt(i-1)===b.charCodeAt(j-1)?0:1;
        cur[j]=Math.min(cur[j-1]+1,prev[j]+1,prev[j-1]+cost);
      }
      for(j=0;j<=n;j++)prev[j]=cur[j];
    }
    return cur[n];
  }
  // Un mot "matche" un token si inclusion franche OU faute proche
  function wordMatch(qword,token){
    if(qword.length<2||token.length<2)return 0;
    if(qword===token)return 1;
    // debut de mot seulement (evite par ex. "rose" trouve dans "brossé")
    if(token.length>=3&&qword.indexOf(token)===0)return 0.92;
    if(qword.length>=3&&token.indexOf(qword)===0)return 0.92;
    // faute d'orthographe : Levenshtein strict, meme premiere lettre
    // (evite par ex. "rose" -> "brode" ou "coton" -> "cordon")
    if(Math.abs(qword.length-token.length)>2)return 0;
    if(qword.charAt(0)!==token.charAt(0))return 0;
    var d=lev(qword,token);
    var maxLen=Math.max(qword.length,token.length);
    var tol=maxLen<=7?1:2;
    if(d<=tol)return 1-(d/maxLen)*0.5;
    return 0;
  }

  // ═══ RECHERCHE ENRICHIE ═══
  // Le moteur cherche dans : titre (poids fort), coloris, balises, categorie,
  // univers et debut de description (poids plus faible). Chaque mot tape est
  // aussi elargi a ses synonymes via le dictionnaire ci-dessous (FR + EN,
  // noms de coloris des fournisseurs inclus). Un mot par groupe suffit :
  // tous les mots d'un meme groupe sont consideres comme equivalents.
  var DICO=[
    /* ── COULEURS ── */
    'noir black ebene jais onyx',
    'blanc white blanche optique',
    'ecru ivoire ivory creme cream natural naturel vanille coquille offwhite',
    'gris grey gray heather chine argent argente silver anthracite charcoal ash cendre acier graphite perle pinchard athletic',
    'bleu blue navy marine royal azur ciel sky indigo cobalt denim ice glacier baby pastel oxford',
    'turquoise cyan aqua teal sarcelle petrole lagon',
    'vert green forest foret olive kaki khaki sauge sage emeraude emerald menthe mint pistache sapin bouteille bottle militaire military camo camouflage',
    'rouge red bordeaux burgundy maroon cardinal cerise cherry grenat carmin vermillon',
    'rose pink fuchsia magenta framboise raspberry blush poudre poudree orchidee orchid',
    'violet purple mauve lilas lilac lavande lavender prune plum aubergine pourpre',
    'jaune yellow moutarde mustard citron lemon dore gold golden soleil maize daisy',
    'orange corail coral peche peach abricot apricot rouille rust terracotta brique brick',
    'marron brun brown chocolat chocolate cafe coffee caramel cognac chataigne noisette',
    'beige sable sand camel taupe tan oat avoine lin',
    'multicolore couleur colore arc-en-ciel rainbow tie-dye',
    /* ── MATIERES ── */
    'coton cotton',
    'bio biologique organic organique ecologique eco ecoresponsable responsable durable recycle recycled gots ocs oekotex',
    'polyester synthetique technique',
    'polaire fleece molleton brosse brossee doux douce',
    'laine wool merinos cachemire cashmere mohair',
    'lin linen',
    'denim jean jeans',
    'cuir leather simili vegan',
    'toile canvas serge twill',
    'soie silk satin',
    'velours velvet cotele',
    'nylon polyamide impermeable deperlant waterproof',
    'elasthanne stretch extensible spandex',
    'pique maille jersey tricot knit',
    /* ── TECHNIQUES / FINITIONS ── */
    'brode brodee broderie embroidered embroidery',
    'imprime imprimee impression print printed dtg dtf serigraphie sublimation',
    'integrale allover all-over complet',
    'motif dessin illustration graphique design visuel artwork',
    'logo monogramme signature embleme',
    /* ── VETEMENTS ── */
    'tshirt tee teeshirt t-shirt tshirts',
    'haut top tops',
    'sweat sweatshirt sweats pull pullover crewneck',
    'hoodie hoodies capuche hood hooded',
    'gilet cardigan zip zippe fermeture',
    'pull tricot maille knit jumper',
    'veste vestes blouson jacket coupe-vent coupevent windbreaker parka manteau coat doudoune anorak',
    'polo polos',
    'chemise shirt surchemise',
    'debardeur tank marcel',
    'crop court courte cropped',
    'maillot jersey jerseys foot football soccer supporter match',
    'bain swim swimwear plage maillotdebain',
    'jogging jogger pantalon survetement bas',
    'short bermuda',
    'robe dress',
    'jupe skirt',
    'legging leggings sport yoga fitness',
    'casquette cap baseball bob bonnet beanie chapeau hat',
    'chaussettes chaussette socks',
    'echarpe scarf foulard',
    'tablier apron',
    'body grenouillere layette',
    /* ── COUPES / PUBLIC ── */
    'oversize ample large loose relax relaxed decontracte boyfriend',
    'ajuste slim fitted cintre moulant',
    'unisexe unisex mixte',
    'homme men man garcon masculin lui',
    'femme women woman fille feminin elle',
    'enfant enfants kids kid junior ado ados',
    'bebe baby naissance',
    'ete summer leger legere lightweight',
    'hiver winter chaud chaude warm epais epaisse',
    /* ── PAPETERIE ── */
    'carnet carnets cahier notebook calepin bloc journal',
    'agenda planner planning organiseur calendrier',
    'pointille dotted bullet bujo quadrille grille grid ligne lignee lined vierge blank',
    'affiche affiches poster posters tableau cadre mural decoration deco art print',
    'carte cartes postale postcard voeux invitation enveloppe papeterie papier',
    'stylo stylos plume crayon feutre pen pencil ecriture',
    'sticker stickers autocollant autocollants vinyle',
    'marque-page marquepage signet bookmark',
    'rigide hardcover couverture relie',
    'spirale reliure',
    /* ── BAGAGERIE ── */
    'sac sacs bag bags',
    'tote totebag cabas shopping courses',
    'dos backpack cartable',
    'sacoche bandouliere besace crossbody messenger',
    'banane bumbag fanny ceinture',
    'trousse pochette etui pouch kit',
    'voyage travel weekend duffle polochon valise',
    'portefeuille wallet porte-cartes cardholder',
    'porte-cles portecles keychain',
    /* ── ACCESSOIRES / MAISON ── */
    'mug mugs tasse cup bol',
    'gourde bouteille bottle thermos isotherme',
    'coque telephone phone iphone samsung case',
    'plaid couverture blanket',
    'coussin cushion oreiller',
    'bougie candle',
    'tapis souris mousepad',
    /* ── OCCASIONS ── */
    'cadeau cadeaux gift offrir present surprise',
    'noel christmas xmas fetes',
    'anniversaire birthday anniv',
    'halloween citrouille sorciere horreur effrayant spooky squelette fantome crane',
    'maman mere mom meres',
    'papa pere dad peres',
    'valentin amour love couple amoureux',
    /* ── UNIVERS ── */
    'royaume medieval chevalier cavalier dragon blason chateau couronne roi reine epique heraldique epee armure',
    'cosmos espace etoile etoiles galaxie planete lune astronaute ciel nebuleuse constellation astro space star eclipse',
    'foret nature arbre feuille renard hibou chouette champignon fee fougere luciole bois animaux enchantee enchante veilleur',
    'mythologie mythe dieu deesse grec grecque antique olympe zeus hades cerbere heros legende temple colonne laurier meduse minotaure'
  ];
  var STOP={de:1,du:1,des:1,la:1,le:1,les:1,un:1,une:1,en:1,et:1,a:1,au:1,aux:1,pour:1,avec:1,sur:1,sans:1,of:1,the:1,and:1};
  var UNIV_LABEL={royaume:'royaume',cosmos:'cosmos',foret:'foret enchantee',mythologie:'mythologie'};
  function tokenize(s){return normalize(s).split(' ').filter(function(t){return t&&!STOP[t];});}
  // Index du dictionnaire : mot -> liste des mots equivalents
  var DICO_IDX={};
  DICO.forEach(function(ligne){
    var mots=[];ligne.split(' ').forEach(function(m){tokenize(m).forEach(function(t){if(mots.indexOf(t)<0)mots.push(t);});});
    mots.forEach(function(m){DICO_IDX[m]=(DICO_IDX[m]||[]).concat(mots);});
  });
  function synonymes(qw){
    var out=[];
    if(DICO_IDX[qw])out=DICO_IDX[qw];
    else if(qw.length>=4){ // debut de mot : "capu" -> capuche
      for(var k in DICO_IDX){if(k.indexOf(qw)===0){out=out.concat(DICO_IDX[k]);}}
    }
    return out.filter(function(m,i,a){return m!==qw&&a.indexOf(m)===i;});
  }
  function uniq(a){return a.filter(function(x,i){return a.indexOf(x)===i;});}
  function buildEntry(it){
    return {item:it,
      title:uniq(tokenize(it.n)),
      col:uniq(tokenize((it.col||[]).join(' '))),
      tags:uniq(tokenize((it.tg||[]).join(' ').replace(/(type|genre|origine):/g,' '))),
      cat:uniq(tokenize((it.c||'')+' '+(UNIV_LABEL[it.u]||''))),
      desc:uniq(tokenize(it.d||''))};
  }
  var INDEX=((typeof GIFT_CATALOG!=='undefined')?GIFT_CATALOG:[]).map(buildEntry);
  // Catalogue charge en arriere-plan : on reconstruit l'index des qu'il est pret,
  // et on affiche les resultats si le client a deja commence a taper.
  if(window.valsenCatalogue){
    window.valsenCatalogue(function(d){
      INDEX=(d||[]).map(buildEntry);
      if(document.activeElement===input&&input.value.trim().length>=2)render(input.value);
    });
  }
  // Poids par champ : un mot du titre compte toujours plus que la description
  var POIDS={title:1,col:.9,tags:.8,cat:.75,desc:.6};

  function bestMatch(qw,tokens){
    var best=0;
    for(var i=0;i<tokens.length;i++){var m=wordMatch(qw,tokens[i]);if(m>best)best=m;if(best>=1)break;}
    return best;
  }
  // Synonymes : correspondance exacte ou debut de mot uniquement (pas de
  // tolerance aux fautes, pour eviter les faux positifs)
  function exactMatch(w,tokens){
    for(var i=0;i<tokens.length;i++){var t=tokens[i];if(t===w)return 1;if(w.length>=4&&t.indexOf(w)===0)return .92;}
    return 0;
  }
  function scoreMot(qw,entry,syn){
    var best=0;
    for(var f in POIDS){
      var tk=entry[f];if(!tk.length)continue;
      // description : pas de tolerance aux fautes (trop de faux positifs)
      var m=(f==='desc'?exactMatch(qw,tk):bestMatch(qw,tk))*POIDS[f];
      if(m<POIDS[f]){for(var j=0;j<syn.length;j++){var ms=exactMatch(syn[j],tk)*POIDS[f]*.9;if(ms>m)m=ms;}}
      if(m>best)best=m;
    }
    return best;
  }
  function search(q){
    var nq=normalize(q);
    if(nq.length<2)return null;
    var qwords=tokenize(nq);
    if(!qwords.length)return null;
    var syns=qwords.map(synonymes);
    var scored=INDEX.map(function(entry){
      var total=0,matchedWords=0;
      qwords.forEach(function(qw,i){
        var best=scoreMot(qw,entry,syns[i]);
        if(best>=0.5)matchedWords++;
        total+=best;
      });
      // bonus si TOUS les mots de la requete matchent ce produit
      var coverage=matchedWords/qwords.length;
      var score=(total/qwords.length)*(0.5+0.5*coverage);
      return {item:entry.item,score:score};
    });
    scored.sort(function(a,b){return b.score-a.score;});
    return scored.filter(function(x){return x.score>=0.5;}).slice(0,6);
  }

  function vig(u,img){
    if(img){return '<img src="'+String(img).replace(/"/g,'&quot;')+'" alt="" style="width:100%;height:100%;object-fit:cover;display:block">';}
    if(typeof gxVignette==='function')return gxVignette(u);
    return '';
  }
  function fmt(p){return typeof geFmt==='function'?geFmt(p):(p+' €');}

  function render(q){
    var hits=search(q);
    if(hits===null){results.classList.remove('show');return;}
    results.classList.add('show');
    if(hits.length===0){
      results.innerHTML='<div class="nsr-hint">Aucun résultat pour « '+q+' »</div>';return;
    }
    results.innerHTML=hits.map(function(h){
      var x=h.item;
      return '<a class="nsr-item h" href="'+(x.url||'/search')+'" style="display:flex;align-items:center;gap:12px"><span class="nsr-vig" style="position:relative;display:block;width:44px;height:44px;flex:0 0 44px;overflow:hidden">'+vig(x.u,x.img)+'</span><span class="nsr-info" style="flex:1;min-width:0;display:block"><span class="nsr-name" style="display:block;white-space:nowrap;overflow:hidden;text-overflow:ellipsis">'+x.n+'</span><span class="nsr-cat" style="display:block;margin-top:2px">'+x.c+'</span></span><span class="nsr-price" style="flex:0 0 auto;white-space:nowrap;margin-left:10px">'+fmt(x.p)+'</span></a>';
    }).join('');
  }

  var t;
  var clearBtn=document.getElementById('nsearch-clear');
  function toggleClear(){ if(clearBtn)clearBtn.classList.toggle('show', input.value.length>0); }
  input.addEventListener('input',function(){clearTimeout(t);toggleClear();t=setTimeout(function(){render(input.value);},120);});
  input.addEventListener('focus',function(){if(window.valsenCatalogue)window.valsenCatalogue();toggleClear();if(input.value.trim().length>=2)render(input.value);});
  if(clearBtn)clearBtn.addEventListener('click',function(){input.value='';toggleClear();results.classList.remove('show');input.focus();});
  document.addEventListener('click',function(e){
    if(!e.target.closest('#nsearch'))results.classList.remove('show');
  });
  input.addEventListener('keydown',function(e){
    if(e.key==='Escape'){input.value='';results.classList.remove('show');input.blur();}
    if(e.key==='Enter'){var first=results.querySelector('.nsr-item');if(first)window.location.href=first.getAttribute('href');}
  });

  /* Barre de recherche de l'accueil (mobile) — réutilise search() ci-dessus */
  (function(){
    var hin=document.getElementById('home-search-in');
    var hres=document.getElementById('home-search-results');
    var hclear=document.getElementById('home-search-clear');
    if(!hin||!hres)return;
    function hrender(q){
      var hits=search(q);
      if(hits===null){hres.classList.remove('show');return;}
      hres.classList.add('show');
      if(hits.length===0){hres.innerHTML='<div class="hsr-hint">Aucun résultat pour « '+q+' »</div>';return;}
      hres.innerHTML=hits.map(function(h){var x=h.item;
        return '<a class="hsr-item" href="'+(x.url||'/search')+'" style="display:flex;align-items:center;gap:12px"><span class="hsr-vig" style="position:relative;display:block;width:44px;height:44px;flex:0 0 44px;overflow:hidden">'+vig(x.u,x.img)+'</span><span class="hsr-info" style="flex:1;min-width:0;display:block"><span class="hsr-name" style="display:block;white-space:nowrap;overflow:hidden;text-overflow:ellipsis">'+x.n+'</span><span class="hsr-cat" style="display:block;margin-top:2px">'+x.c+'</span></span><span class="hsr-price" style="flex:0 0 auto;white-space:nowrap;margin-left:10px">'+fmt(x.p)+'</span></a>';
      }).join('');
    }
    var ht;
    function htoggle(){if(hclear)hclear.classList.toggle('show',hin.value.length>0);}
    hin.addEventListener('input',function(){clearTimeout(ht);htoggle();ht=setTimeout(function(){hrender(hin.value);},120);});
    hin.addEventListener('focus',function(){if(window.valsenCatalogue)window.valsenCatalogue();htoggle();if(hin.value.trim().length>=2)hrender(hin.value);});
    if(window.valsenCatalogue)window.valsenCatalogue(function(){ if(document.activeElement===hin&&hin.value.trim().length>=2)hrender(hin.value); });
    if(hclear)hclear.addEventListener('click',function(){hin.value='';htoggle();hres.classList.remove('show');hin.focus();});
    document.addEventListener('click',function(e){if(!e.target.closest('#home-search'))hres.classList.remove('show');});
    hin.addEventListener('keydown',function(e){
      if(e.key==='Escape'){hin.value='';hres.classList.remove('show');hin.blur();}
      if(e.key==='Enter'){var f=hres.querySelector('.hsr-item');if(f)window.location.href=f.getAttribute('href');}
    });
  })();
})();

/* ── FILTRES + TRI BOUTIQUE ── */
var filterBar=document.getElementById('filter-bar');
var sortSel=document.getElementById('sort-select')||document.createElement('select');
var shopGrid=document.getElementById('shop-grid');
if(shopGrid){
  var activeCat='all';
  function priceOf(card){
    var el=card.querySelector('.pc-price');
    if(!el)return 0;
    var m=el.textContent.replace(/\s/g,'').replace(',','.').match(/([0-9]+(\.[0-9]+)?)/);
    return m?parseFloat(m[1]):0;
  }
  function nameOf(card){var el=card.querySelector('.pc-name');return el?el.textContent.trim().toLowerCase():'';}
  // mémoriser l'ordre d'origine pour "Recommandés"
  var cards=Array.prototype.slice.call(shopGrid.querySelectorAll('.pc'));
  cards.forEach(function(c,i){c.dataset.idx=i;});

  var subnav=document.getElementById('subnav')||document.createElement('div');
  var subBack=document.getElementById('sub-back')||document.createElement('div');
  var subBackLabel=document.getElementById('sub-back-label')||document.createElement('span');
  var subBackBtn=document.getElementById('sub-back-btn')||document.createElement('button');
  var genreBar=document.getElementById('genre-bar');
  if(genreBar)genreBar.style.display='none';

  var GENRED={vetements:1,accessoires:1};
  var TYPED={papeterie:1,bagagerie:1};
  // état de navigation
  var activeGenre=null, activeType=null, step='cat';

  var GENRE_ICO={
    homme:'<svg width="50" height="50" viewBox="0 0 100 90"><path d="M18,18 L0,36 L18,41 L18,82 L82,82 L82,41 L100,36 L82,18 L64,9 Q50,0 36,9Z" fill="none" stroke="#6b5a34" stroke-width="1.4"/></svg>',
    femme:'<svg width="44" height="56" viewBox="0 0 84 110"><path d="M28,10 L18,28 L26,32 L14,100 L70,100 L58,32 L66,28 L56,10 L48,6 Q42,12 36,6Z" fill="none" stroke="#6b5a34" stroke-width="1.4"/></svg>',
    enfant:'<svg width="44" height="44" viewBox="0 0 100 90"><path d="M22,22 L6,38 L22,42 L22,80 L78,80 L78,42 L94,38 L78,22 L62,14 Q50,8 38,14Z" fill="none" stroke="#6b5a34" stroke-width="1.4"/></svg>',
    bebe:'<svg width="46" height="48" viewBox="0 0 84 90"><path d="M22,14 L6,28 L14,44 L22,40 L20,66 Q24,82 42,80 Q60,82 64,66 L62,40 L70,44 L78,28 L62,14 L50,8 Q42,14 34,8Z" fill="none" stroke="#6b5a34" stroke-width="1.4"/></svg>'
  };
  var GENRE_LABEL={homme:'Homme',femme:'Femme',enfant:'Enfant',bebe:'Bébé'};
  // libellés lisibles des types
  var TYPE_LABEL={
    tshirts:'T-shirts',debardeurs:'Débardeurs',sweats:'Sweats & Pulls',hoodies:'Sweats & Pulls',polos:'Polos',
    vestes:'Vestes & Blousons','coupe-vent':'Vestes & Blousons',
    chemises:'Chemises',robes:'Robes',jupes:'Jupes',tops:'Tops',sport:'Sport & yoga',
    maillots:'Maillots de bain',jerseys:'Maillots',sousvet:'Sous-vêtements',bebe:'Layette',chaussettes:'Chaussettes',
    chapeaux:'Casquettes & bonnets',mugs:'Mugs & gourdes',maison:'Maison',
    'textile-acc':'Textile',tech:'Tech & stickers',elegance:'Élégance',
    'maroquinerie-acc':'Maroquinerie','bebe-acc':'Bébé',
    carnets:'Carnets & journaux',affiches:'Affiches & posters',cartes:'Cartes & papier',
    sacs:'Sacs',maroquinerie:'Petite maroquinerie',cuir:'Premium cuir'
  };
  var TYPE_ICO={
    tshirts:'<svg width="52" height="48" viewBox="0 0 100 90"><path d="M18,18 L0,36 L18,41 L18,82 L82,82 L82,41 L100,36 L82,18 L64,9 Q50,0 36,9Z" fill="none" stroke="#6b5a34" stroke-width="1.3"/></svg>',
    jerseys:'<svg width="52" height="48" viewBox="0 0 100 90"><path d="M18,18 L0,36 L18,41 L18,82 L82,82 L82,41 L100,36 L82,18 L62,10 L50,20 L38,10Z" fill="none" stroke="#6b5a34" stroke-width="1.3"/><text x="50" y="60" text-anchor="middle" font-family="serif" font-size="20" fill="#6b5a34">10</text></svg>',
    debardeurs:'<svg width="44" height="48" viewBox="0 0 90 94"><path d="M22,14 L14,30 L22,33 L22,86 L68,86 L68,33 L76,30 L68,14 L56,14 Q45,22 34,14Z" fill="none" stroke="#6b5a34" stroke-width="1.3"/></svg>',
    sweats:'<svg width="50" height="46" viewBox="0 0 100 90"><path d="M22,18 L4,32 L12,52 L22,48 L22,84 L78,84 L78,48 L88,52 L96,32 L78,18 L62,12 Q50,8 38,12Z" fill="none" stroke="#6b5a34" stroke-width="1.3"/></svg>',
    vestes:'<svg width="50" height="48" viewBox="0 0 100 92"><path d="M22,16 L4,30 L12,52 L22,47 L22,86 L46,86 L46,22 M54,22 L54,86 L78,86 L78,47 L88,52 L96,30 L78,16 L62,10 L54,22 L50,26 L46,22 L38,10Z" fill="none" stroke="#6b5a34" stroke-width="1.3"/><path d="M50,30 L50,80" stroke="#6b5a34" stroke-width="1" stroke-dasharray="3,3"/></svg>',
    'coupe-vent':'<svg width="50" height="48" viewBox="0 0 100 92"><path d="M22,16 L4,30 L12,52 L22,47 L22,86 L46,86 L46,22 M54,22 L54,86 L78,86 L78,47 L88,52 L96,30 L78,16 L62,10 L54,22 L50,26 L46,22 L38,10Z" fill="none" stroke="#6b5a34" stroke-width="1.3"/><path d="M50,30 L50,80" stroke="#6b5a34" stroke-width="1" stroke-dasharray="3,3"/></svg>',
    hoodies:'<svg width="50" height="46" viewBox="0 0 100 92"><path d="M25,26 Q16,16 4,21 L8,44 L22,39 L22,84 L78,84 L78,39 L92,44 L96,21 Q84,16 75,26 Q62,2 38,2 Q16,2 25,26Z" fill="none" stroke="#6b5a34" stroke-width="1.2"/></svg>',
    polos:'<svg width="52" height="48" viewBox="0 0 100 90"><path d="M18,18 L0,36 L18,41 L18,82 L82,82 L82,41 L100,36 L82,18 L60,12 L50,24 L40,12Z" fill="none" stroke="#6b5a34" stroke-width="1.3"/></svg>',
    chemises:'<svg width="52" height="48" viewBox="0 0 100 90"><path d="M18,18 L0,36 L18,41 L18,82 L82,82 L82,41 L100,36 L82,18 L60,14 L50,20 L40,14Z M50,20 L50,80" fill="none" stroke="#6b5a34" stroke-width="1.3"/></svg>',
    robes:'<svg width="42" height="56" viewBox="0 0 84 110"><path d="M28,10 L18,28 L26,32 L14,100 L70,100 L58,32 L66,28 L56,10 L48,6 Q42,12 36,6Z" fill="none" stroke="#6b5a34" stroke-width="1.3"/></svg>',
    jupes:'<svg width="46" height="44" viewBox="0 0 88 84"><path d="M22,8 L66,8 L78,76 L10,76Z" fill="none" stroke="#6b5a34" stroke-width="1.3"/></svg>',
    tops:'<svg width="44" height="48" viewBox="0 0 90 94"><path d="M22,14 L14,30 L22,33 L22,86 L68,86 L68,33 L76,30 L68,14 L56,14 Q45,22 34,14Z" fill="none" stroke="#6b5a34" stroke-width="1.3"/></svg>',
    sport:'<svg width="34" height="58" viewBox="0 0 60 120"><path d="M12,6 L48,6 L46,60 L40,114 L32,114 L30,64 L28,114 L20,114 L14,60Z" fill="none" stroke="#6b5a34" stroke-width="1.3"/></svg>',
    maillots:'<svg width="50" height="40" viewBox="0 0 90 70"><path d="M10,10 L80,10 L72,40 Q60,56 45,48 Q30,56 18,40Z" fill="none" stroke="#6b5a34" stroke-width="1.3"/></svg>',
    sousvet:'<svg width="50" height="38" viewBox="0 0 90 64"><path d="M8,8 L82,8 L74,30 Q60,52 45,40 Q30,52 16,30Z" fill="none" stroke="#6b5a34" stroke-width="1.3"/></svg>',
    chaussettes:'<svg width="40" height="58" viewBox="0 0 70 110"><path d="M22,8 L46,8 L46,64 L60,86 Q50,104 32,96 L18,72 Q22,68 22,64Z" fill="none" stroke="#6b5a34" stroke-width="1.3"/></svg>',
    bebe:'<svg width="46" height="48" viewBox="0 0 84 90"><path d="M22,14 L6,28 L14,44 L22,40 L20,66 Q24,82 42,80 Q60,82 64,66 L62,40 L70,44 L78,28 L62,14 L50,8 Q42,14 34,8Z" fill="none" stroke="#6b5a34" stroke-width="1.3"/></svg>',
    chapeaux:'<svg width="56" height="38" viewBox="0 0 104 68"><path d="M16,44 Q16,14 52,14 Q88,14 88,44 Z" fill="none" stroke="#6b5a34" stroke-width="1.3"/><path d="M88,44 Q104,46 100,54 L60,54 Q88,50 88,44Z" fill="none" stroke="#6b5a34" stroke-width="1.3"/></svg>',
    mugs:'<svg width="50" height="46" viewBox="0 0 92 84"><rect x="14" y="14" width="50" height="60" rx="4" fill="none" stroke="#6b5a34" stroke-width="1.3"/><path d="M64,28 Q84,28 84,44 Q84,60 64,60" fill="none" stroke="#6b5a34" stroke-width="1.6"/></svg>',
    maison:'<svg width="54" height="54" viewBox="0 0 100 100"><path d="M16,16 L84,16 L84,84 L16,84Z" fill="none" stroke="#6b5a34" stroke-width="1.3"/></svg>',
    'textile-acc':'<svg width="40" height="58" viewBox="0 0 70 110"><path d="M22,8 L46,8 L46,64 L60,86 Q50,104 32,96 L18,72 Q22,68 22,64Z" fill="none" stroke="#6b5a34" stroke-width="1.3"/></svg>',
    tech:'<svg width="36" height="58" viewBox="0 0 60 116"><rect x="10" y="6" width="40" height="104" rx="8" fill="none" stroke="#6b5a34" stroke-width="1.3"/></svg>',
    elegance:'<svg width="30" height="58" viewBox="0 0 48 120"><path d="M18,8 L30,8 L26,28 L34,40 L30,108 L24,116 L18,108 L14,40 L22,28Z" fill="none" stroke="#6b5a34" stroke-width="1.3"/></svg>',
    'maroquinerie-acc':'<svg width="56" height="40" viewBox="0 0 104 74"><rect x="12" y="14" width="80" height="50" rx="4" fill="none" stroke="#6b5a34" stroke-width="1.3"/></svg>',
    'bebe-acc':'<svg width="44" height="48" viewBox="0 0 80 86"><path d="M30,8 Q40,18 50,8 Q70,16 68,40 Q66,76 40,80 Q14,76 12,40 Q10,16 30,8Z" fill="none" stroke="#6b5a34" stroke-width="1.3"/></svg>'
  };

  // Un produit peut porter plusieurs genres (data-genre="homme femme") ;
  // "mixte" (aucune balise genre) correspond a tous les genres.
  function hasGenre(c,genre){
    var g=(c.getAttribute('data-genre')||'mixte').split(/\s+/);
    return g.indexOf(genre)>=0||g.indexOf('mixte')>=0;
  }
  function typesFor(cat,genre){
    var seen=[],out=[];
    cards.forEach(function(c){
      if(c.getAttribute('data-cat')!==cat)return;
      if(genre && !hasGenre(c,genre))return;
      var t=c.getAttribute('data-type');
      if(t && seen.indexOf(t)<0){seen.push(t);out.push(t);}
    });
    return out;
  }
  function countType(cat,genre,t){
    return cards.filter(function(c){
      if(c.getAttribute('data-cat')!==cat)return false;
      if(c.getAttribute('data-type')!==t)return false;
      if(genre){return hasGenre(c,genre);}
      return true;
    }).length;
  }
  function countGenre(cat,genre){
    return cards.filter(function(c){
      if(c.getAttribute('data-cat')!==cat)return false;
      return hasGenre(c,genre);
    }).length;
  }

  function makeCard(sub,label,ico,count,onClick){
    var el=document.createElement('button');
    el.className='subcard h';el.setAttribute('data-sub',sub);
    el.innerHTML=ico+'<div class="subcard-label">'+label+'</div><div class="subcard-count">'+count+' articles</div>';
    el.addEventListener('click',onClick);
    return el;
  }

  // libellés "tout" par catégorie
  var ALL_CAT_LABEL={vetements:'Tous les vêtements',accessoires:'Tous les accessoires',papeterie:'Toute la papeterie',bagagerie:'Toute la bagagerie'};
  var ALL_ICO='<svg width="50" height="50" viewBox="0 0 100 100"><rect x="14" y="14" width="32" height="32" rx="2" fill="none" stroke="#6b5a34" stroke-width="1.3"/><rect x="54" y="14" width="32" height="32" rx="2" fill="none" stroke="#6b5a34" stroke-width="1.3"/><rect x="14" y="54" width="32" height="32" rx="2" fill="none" stroke="#6b5a34" stroke-width="1.3"/><rect x="54" y="54" width="32" height="32" rx="2" fill="none" stroke="#6b5a34" stroke-width="1.3"/></svg>';

  function setBackLabel(txt){
    if(!subBackLabel)return;
    if(!txt){subBackLabel.innerHTML='';return;}
    var parts=txt.split(' · ');
    subBackLabel.innerHTML=parts.map(function(p,i){
      var last=i===parts.length-1;
      return (i>0?'<span style="color:var(--gold,#b8960c);font-style:normal;margin:0 2px">/</span>':'')
        +'<span style="'+(last?'color:var(--b)':'color:var(--mid)')+'">'+p+'</span>';
    }).join('');
  }

  function showAllOf(genre){
    // affiche tous les produits de la catégorie (et du genre si fourni)
    activeGenre=genre||null;activeType=null;step='list';
    subnav.classList.remove('show');
    if(subBack)subBack.style.display='flex';
    var catName={vetements:'Vêtements',accessoires:'Accessoires',papeterie:'Papeterie',bagagerie:'Bagagerie'}[activeCat]||'';
    setBackLabel(genre?(catName+' · '+GENRE_LABEL[genre]):catName);
    apply();
  }

  // affiche les cartes de GENRE (niveau 1 pour vetements/accessoires)
  function showGenres(){
    step='genre';activeGenre=null;activeType=null;
    subnav.innerHTML='';
    // carte "Tous les vêtements/accessoires"
    var nAll=cards.filter(function(c){return c.getAttribute('data-cat')===activeCat;}).length;
    subnav.appendChild(makeCard('__all',ALL_CAT_LABEL[activeCat]||'Tout voir',ALL_ICO,nAll,function(){showAllOf(null);}));
    ['homme','femme','enfant','bebe'].forEach(function(g){
      var n=countGenre(activeCat,g);
      if(n===0)return;
      subnav.appendChild(makeCard(g,GENRE_LABEL[g],GENRE_ICO[g],n,function(){selectGenre(g);}));
    });
    subnav.classList.add('show');
    shopGrid.style.display='none';
    if(subBack)subBack.style.display='none';
  }
  // affiche les cartes de TYPE (niveau 2)
  function showTypes(){
    step='type';activeType=null;
    subnav.innerHTML='';
    // carte "Tout" du niveau courant
    var catWord={vetements:'les vêtements',accessoires:'les accessoires',papeterie:'la papeterie',bagagerie:'la bagagerie'}[activeCat]||'';
    var allLabel = activeGenre ? ('Tous les '+ (activeCat==='accessoires'?'accessoires':'vêtements') +' '+GENRE_LABEL[activeGenre].toLowerCase()) : ('Tout'+(catWord.indexOf('la')===0?'e ':' ')+catWord);
    var nAll = activeGenre?countGenre(activeCat,activeGenre):cards.filter(function(c){return c.getAttribute('data-cat')===activeCat;}).length;
    subnav.appendChild(makeCard('__all',allLabel,ALL_ICO,nAll,function(){showAllOf(activeGenre);}));
    var list=typesFor(activeCat,activeGenre);
    list.forEach(function(t){
      var n=activeGenre?countType(activeCat,activeGenre,t):countType(activeCat,null,t);
      subnav.appendChild(makeCard(t,TYPE_LABEL[t]||t,TYPE_ICO[t]||'',n,function(){selectType(t);}));
    });
    subnav.classList.add('show');
    shopGrid.style.display='none';
    // au niveau "type", le retour ramène aux genres : on affiche le bouton avec le genre courant
    if(subBack){
      if(GENRED[activeCat]&&activeGenre){subBack.style.display='flex';var cn={vetements:'Vêtements',accessoires:'Accessoires'}[activeCat]||'';setBackLabel(cn+' · '+GENRE_LABEL[activeGenre]);}
      else{subBack.style.display='none';setBackLabel('');}
    }
  }

  function selectGenre(g){activeGenre=g;showTypes();}
  function selectType(t){
    activeType=t;step='list';
    subnav.classList.remove('show');
    if(subBack)subBack.style.display='flex';
    var catName={vetements:'Vêtements',accessoires:'Accessoires',papeterie:'Papeterie',bagagerie:'Bagagerie'}[activeCat]||'';
    var parts=[catName];
    if(activeGenre)parts.push(GENRE_LABEL[activeGenre]);
    parts.push(TYPE_LABEL[t]||t);
    setBackLabel(parts.join(' · '));
    apply();
  }

  function apply(){
    var sort=sortSel?sortSel.value:'default';
    var arr=cards.slice();
    if(sort==='price-asc')arr.sort(function(a,b){return priceOf(a)-priceOf(b);});
    else if(sort==='price-desc')arr.sort(function(a,b){return priceOf(b)-priceOf(a);});
    else if(sort==='name-asc')arr.sort(function(a,b){return nameOf(a).localeCompare(nameOf(b));});
    else if(sort==='name-desc')arr.sort(function(a,b){return nameOf(b).localeCompare(nameOf(a));});
    else arr.sort(function(a,b){return a.dataset.idx-b.dataset.idx;});

    var showGrid=(activeCat==='all')||(step==='list');
    arr.forEach(function(card){
      shopGrid.appendChild(card);
      var show=false;
      if(showGrid){
        if(activeCat==='all'){show=true;}
        else if(card.getAttribute('data-cat')===activeCat){
          var okType=(!activeType)||card.getAttribute('data-type')===activeType;
          var okGenre=true;
          if(GENRED[activeCat]&&activeGenre){okGenre=hasGenre(card,activeGenre);}
          show=okType&&okGenre;
        }
      }
      card.style.display=show?'block':'none';
    });
    shopGrid.style.display=showGrid?'':'none';
  }

  function resetToCat(cat){
    activeCat=cat;activeGenre=null;activeType=null;step='cat';
    if(subBack)subBack.style.display='none';
    if(cat==='all'){if(subnav)subnav.classList.remove('show');apply();}
    else if(GENRED[cat]){showGenres();}
    else if(TYPED[cat]){activeGenre=null;showTypes();}
    else{if(subnav)subnav.classList.remove('show');apply();}
  }

  // retour : list -> types ; types -> genres (ou cat si non genré)
  function goBack(){
    if(step==='list'){
      // si on est dans une catégorie genrée
      if(GENRED[activeCat]){
        if(activeType){showTypes();}        // liste d'un type -> retour aux types du genre
        else if(activeGenre){showTypes();}   // "tout le genre" -> retour aux types du genre
        else{showGenres();}                  // "tous les vêtements" -> retour aux genres
      } else if(TYPED[activeCat]){
        showTypes();                          // retour aux types
      } else {
        resetToCat(activeCat);
      }
    } else if(step==='type'){
      if(GENRED[activeCat]){showGenres();}    // retour aux genres
      else{resetToCat('all');filterActive('all');} // papeterie/bagagerie -> retour à Tout
    }
  }
  function filterActive(cat){
    if(!filterBar)return;
    filterBar.querySelectorAll('.filter').forEach(function(x){x.classList.toggle('active',x.getAttribute('data-cat')===cat);});
  }

  if(filterBar)filterBar.addEventListener('click',function(e){
    var f=e.target.closest('.filter');if(!f)return;
    filterBar.querySelectorAll('.filter').forEach(function(x){x.classList.remove('active')});
    f.classList.add('active');
    resetToCat(f.getAttribute('data-cat'));
  });
  if(subBackBtn)subBackBtn.addEventListener('click',goBack);
  if(sortSel)sortSel.addEventListener('change',apply);
  // état initial : "Tout" -> afficher tous les produits
  resetToCat('all');
}
})();

/* ── MENU LATÉRAL (side drawer) ── */
(function(){
  var btn=document.getElementById('nmenu-btn');
  var menu=document.getElementById('sidemenu');
  var overlay=document.getElementById('sidemenu-overlay');
  var closeBtn=document.getElementById('sidemenu-close');
  if(!btn||!menu||!overlay)return;
  function open(){menu.classList.add('open');overlay.classList.add('open');btn.classList.add('open');document.body.style.overflow='hidden';}
  function close(){menu.classList.remove('open');overlay.classList.remove('open');btn.classList.remove('open');document.body.style.overflow='';}
  btn.addEventListener('click',open);
  overlay.addEventListener('click',close);
  if(closeBtn)closeBtn.addEventListener('click',close);
  document.addEventListener('keydown',function(e){if(e.key==='Escape')close();});
})();

/* ── RECHERCHE MOBILE : déplace la barre #nsearch dans le menu latéral ──
   Sur mobile, la barre de recherche de la nav est masquée (manque de place).
   On la déplace dans le menu burger (#sidemenu) où elle reste pleinement
   fonctionnelle (mêmes écouteurs JS). Sur desktop, elle revient dans la nav. */
(function(){
  var search=document.getElementById('nsearch');
  var slot=document.getElementById('sidemenu-search-slot');
  if(!search||!slot)return;
  var navHome=search.parentElement;            // emplacement d'origine (dans .nright)
  var navNext=search.nextSibling;              // pour réinsérer au bon endroit
  var mq=window.matchMedia('(max-width:900px)');
  function place(){
    if(mq.matches){
      if(search.parentElement!==slot)slot.appendChild(search);
    }else{
      if(search.parentElement!==navHome){
        if(navNext&&navNext.parentElement===navHome)navHome.insertBefore(search,navNext);
        else navHome.appendChild(search);
      }
    }
  }
  place();
  if(mq.addEventListener)mq.addEventListener('change',place);
  else if(mq.addListener)mq.addListener(place);
})();
